export const FETCH_BRAND_PENDING = 'FETCH_BRAND_PENDING';
export const FETCH_BRAND_REJECTED = 'FETCH_BRAND_REJECTED';
export const FETCH_BRAND_FULFILLED = 'FETCH_BRAND_FULFILLED';



// WEBPACK FOOTER //
// ./src/constants/brandDetail.js